import React from "react";
import { motion } from "framer-motion";
import Header from "./Header";
// import homeImageBackground from "../assets/images/homeBackground.png";
import homeImageBackground from "../assets/images/bg-light.png";
import homeImageBackgroundDark from "../assets/images/bg-dark.png";
import blurBoxBg from "../assets/images/blur-box-bg.png";
import blurBoxLight from "../assets/images/blur-box-light.png";
import blurBoxDark from "../assets/images/blur-box-dark.png";
import { useDarkMode } from "../DarkModeProvider";

const STYLES = {
  Base: " space-y-3 md:p-8 p-4 bg-white/20 shadow-xl rounded-xl bg-clip-padding  backdrop-filter dark:bg-white/10 overflow-y-scroll mx-auto",
  v1: " lg:w-[70%] 2xl:w-[60%] md:w-[90%] w-[95%]",
  auth: " w-full lg:max-w-[40%] max-w-[90%]  pb-8",
  moreWidth: " w-full lg:max-w-[80%] max-w-[90%]  pb-8",
};

const Layout = ({
  children,
  variant = "v1",
  setHeight = true,

}) => {
  const { isDarkMode } = useDarkMode();
  return (
    <div
      className="flex flex-col relative min-h-screen overflow-hidden bg-hero-pattern bg-no-repeat bg-cover bg-center h-screen"
      style={{
        backgroundImage: `url(${isDarkMode ? homeImageBackgroundDark : homeImageBackground
          })`,
      }}
    >
      <div className="mt-6">
        <Header />
      </div>

      <div className="pt-8 md:pt-16 pb-6 md:pb-10">
        <motion.div
          // className="md:-mt-20"
          // initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.5 }}
          variants={{
            hidden: { opacity: 0, x: -50 },
            visible: { opacity: 1, x: 0 },
          }}
          className={`${STYLES.Base} ${STYLES[variant]} ${setHeight ? "blurry-container" : "min-h-[100px]"
            } 
          bg-no-repeat bg-cover bg-center
          
          `}
          style={{
            backgroundImage: `url(${isDarkMode ? blurBoxDark : blurBoxLight})`,
          }}
        >
          {children}
        </motion.div>
      </div>
    </div>
  );
};

export default Layout;

// ${!isDragging && dragConflictClass}
